// extracted by mini-css-extract-plugin
export default {"deleteButton":"styles_deleteButton__Yo91Z"};